import React, { useRef, useState, useEffect } from "react";
import { SlArrowLeft, SlArrowRight } from "react-icons/sl";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Autoplay } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";
import "./HomeReelSection.css";
import { RiShareForwardLine } from "react-icons/ri";
import { FaWhatsapp } from "react-icons/fa";
import { MdOutlinePhone } from "react-icons/md";
import { HiOutlineArrowsExpand } from "react-icons/hi";
import { IoIosPause, IoMdPlay } from "react-icons/io";
import { getReels } from "../../../API/home";
import { useNavigate } from "react-router-dom";
import SharePopUp from "../sharepopup/sharepopup";
import ReelOverlay from "./ReelOverlay";
import { handleContactRedirect } from "../../handleContactRedirect";
import { FaInstagram } from "react-icons/fa";
import { HiVolumeUp, HiVolumeOff } from "react-icons/hi";
/* ── Reel Card ── */
const ReelCard = ({
  src,
  poster,
  phone,
  whatsapp,
  shareUrl,
  onExpand,
  onShareClick,
}) => {
  const videoRef = useRef(null);
  const [playing, setPlaying] = useState(false);
  const [hovered, setHovered] = useState(false);
    const [muted, setMuted] = useState(true);
  const navigate = useNavigate();
  const showPlayButton = !playing || hovered;
  const togglePlay = async () => {
    const vid = videoRef.current;
    if (!vid) return;

    if (vid.paused) {
      try {
        await vid.play();
      } catch (err) { }
    } else {
      vid.pause();
    }
  };
  const toggleMute = () => {
    setMuted((prev) => {
      if (videoRef.current) videoRef.current.muted = !prev;
      return !prev;
    });
  };

  return (
    <>
      <div>
        <div className="hrs-card"
          onMouseEnter={() => setHovered(true)}
          onMouseLeave={() => setHovered(false)}
        >
          {src ? (
            <video
              ref={videoRef}
              src={src}
              playsInline
              muted
              controls={false}
              preload="metadata"
              className="hrs-video"
              onPlay={() => setPlaying(true)}
              onPause={() => setPlaying(false)}
              onEnded={() => setPlaying(false)}
            />
          ) : (
            <img
              src={poster || "/assets/homepageicons/DummyImage.png"}
              alt="fallback"
              className="hrs-video"
            />
          )}
          {/* ── Top-left: Mute button ── */}
          <button
            className="ovl-btn ovl-mute-btn" style={{width:"30px", height:"30px", top:"8px", left:"8px"}}
            onClick={toggleMute}
            title={muted ? "Unmute" : "Mute"}
          >
            {muted ? <HiVolumeOff size={18} /> : <HiVolumeUp size={18} />}
          </button>
          <div className="hrs-top-icons">
            <button
              className="hrs-icon-btn"
              onClick={() => (window.location.href = `tel:${phone}`)}
            >
              <MdOutlinePhone size={16} />
            </button>
            <button
              className="hrs-icon-btn"
              onClick={() => window.open(`https://wa.me/${whatsapp}`, "_blank")}
            >
              <FaWhatsapp size={16} />
            </button>
            <button
              className="hrs-icon-btn"
              onClick={() =>
                window.open("https://www.instagram.com/blueberry_dmc/", "_blank")
              }
            >
              <FaInstagram size={16} />
            </button>
            <button
              className="hrs-icon-btn"
              onClick={(e) => {
                e.stopPropagation();
                onShareClick(src); // ✅ directly pass video src
              }}
            >
              <RiShareForwardLine size={16} />
            </button>
          </div>
          {showPlayButton && (
            <button
              className="hrs-play-btn"
              onClick={togglePlay}
            >
              {playing ? (
                <IoIosPause size={22} color="#fff" />
              ) : (
                <IoMdPlay size={22} color="#fff" />
              )}
            </button>
          )}
          <button className="hrs-fullscreen-btn" onClick={onExpand}>
            <HiOutlineArrowsExpand size={16} color="#001F3D" />
          </button>
        </div>

        <button
          className="hrs-enquire-btn"
          onClick={() => handleContactRedirect(navigate)}
        >
          Enquire Now
        </button>
      </div>
    </>
  );
};

/* ── MAIN SECTION ── */
export const HomeReelSection = ({ onEnquire }) => {
  const [expandedIndex, setExpandedIndex] = useState(null);
  const [reels, setReels] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showShare, setShowShare] = useState(false);
  const [currentShareUrl, setCurrentShareUrl] = useState("");
  const prevRef = useRef(null);
  const nextRef = useRef(null);
  const handleShareClick = (url) => {
    setCurrentShareUrl(url);
    setShowShare(true);
  };

  useEffect(() => {
    if (showShare) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "";
    }
  }, [showShare]);

  useEffect(() => {
    const fetchReels = async () => {
      try {
        const apiData = await getReels();

        console.log("Reels API:", apiData); // debug

        const formatted = apiData.map((item) => ({
          src: item.videoPath?.startsWith("http")
            ? item.videoPath
            : `https://uatadmin.blueberrydmc.com${item.videoPath}`,

          // ✅ ADD THIS
          description: item.description || "",
        }));

        setReels(formatted);
      } catch (err) {
        console.error(err);
      } finally {
        setLoading(false);
      }
    };

    fetchReels();
  }, []);

  return (
    <div className="hrs-section standard-padding">
      <div className="hrs-slider-wrapper">
        {loading ? (
          <p style={{ textAlign: "center" }}>Loading...</p>
        ) : (
          <Swiper
            modules={[Navigation]}
            spaceBetween={6}
            slidesPerView={4}
            loop={true}
            onBeforeInit={(swiper) => {
              swiper.params.navigation.prevEl = prevRef.current;
              swiper.params.navigation.nextEl = nextRef.current;
            }}
            navigation={{
              prevEl: prevRef.current,
              nextEl: nextRef.current,
            }}
            breakpoints={{
              0: { slidesPerView: 1 },
              768: { slidesPerView: 2 },
              1200: { slidesPerView: 4 },
            }}
            className="hrs-section-slider"
          >
            {reels.map((reel, i) => (
              <SwiperSlide key={i}>
                <div className="hrs-slide">
                  <ReelCard
                    {...reel}
                    onExpand={() => setExpandedIndex(i)}
                    onShareClick={handleShareClick}
                  />
                </div>
              </SwiperSlide>
            ))}
          </Swiper>
        )}

        {/* ARROWS */}
        <div ref={prevRef} className="hrs-arrow hrs-arrow--prev">
          <SlArrowLeft fontSize={26} />
        </div>

        <div ref={nextRef} className="hrs-arrow hrs-arrow--next">
          <SlArrowRight fontSize={26} />
        </div>
      </div>

      {/* Share popup */}
      {showShare && (
        <div className="hrs-share-backdrop" onClick={() => setShowShare(false)}>
          <div onClick={(e) => e.stopPropagation()}>
            <SharePopUp
              title="Share"
              shareurl={currentShareUrl || window.location.href}
              showmail
              showwhatsapp
              showfacebook
              showLinkedin
              onClose={() => setShowShare(false)}
            />
          </div>
        </div>
      )}

      {expandedIndex !== null && (
        <ReelOverlay
          reels={reels}
          startIndex={expandedIndex}
          title="Share"
          shareurl={currentShareUrl || window.location.href}
          showmail
          showwhatsapp
          showfacebook
          showLinkedin
          onClose={() => setExpandedIndex(null)}
        />
      )}
    </div>
  );
};

export default HomeReelSection;
